/**
 * Constants definition.
 *
 * @type {{DRAFT: string, SENT: string, IN_REVIEW: string, CANCELED: string, ACCEPTED: string, REJECTED: string}}
 */
const PROCEDURE_STATUS = {
  DRAFT: 'DRAFT',
  SENT: 'SENT',
  IN_REVIEW: 'IN_REVIEW',
  CANCELED: 'CANCELED',
  REVIEWED: 'REVIEWED',
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED',
  COMPLETED: 'COMPLETED',
};

/**
 * Enum definition.
 *
 * @type {string[]}
 */
const PROCEDURE_STATUS_ENUM = Object.keys(PROCEDURE_STATUS);

export {
  PROCEDURE_STATUS_ENUM,
  PROCEDURE_STATUS,
};
